/*!
 * lavettildig.dk – uploadwidget (vanilla JS, ingen afhængigheder)
 * Indsættes via Shopify theme-snippet / custom liquid. Se docs/WIDGET.md.
 *
 * Markup:
 *   <div data-lvd-upload data-endpoint="https://upload.lavettildig.dk"
 *        data-product-type="mug" data-required="true"></div>
 *
 * Sætter en skjult linjeegenskab `properties[_upload_id]` i produktformularen.
 * Al tekst til kunden er på dansk. Al visning bygges med DOM-API (ingen innerHTML med brugerdata).
 */
(function () {
  'use strict';

  // HEIC/HEIF (iPhone) modtages også; serveren gemmer dem som JPG. Nævnes ikke i hjælpeteksten (Legal-tekst v4).
  var ALLOWED = { 'image/jpeg': 1, 'image/png': 1, 'image/webp': 1, 'image/heic': 1, 'image/heif': 1 };
  var EXT = /\.(jpe?g|png|webp|heic|heif)$/i;
  var HEIC_EXT = /\.(heic|heif)$/i;

  // Legals tekster – ORDRET fra det uforanderlige arkiv legal-texts/v3.md (SHA-256 nedenfor).
  // Filtyper/maks. størrelse i hjælpeteksten genereres fra konfigurationen (data-max-mb); en test sikrer, at
  // resultatet er identisk med v3.md, når konfigurationen er 25 MB / JPG, PNG, WebP. Ny tekst = ny version + hash.
  var CONSENT_VERSION = 'v4';
  var CONSENT_HASH = 'd02ea8f7006a6616768875496acd808ccb153be797649f8ddf9dc38c19aa70b4';
  var LEGAL = {
    heading: 'Send dit billede',
    helpRest: 'Billedet sendes krypteret til vores egen server i Danmark og bruges kun til at lave din bestilling.',
    consentBold: 'Jeg har ret til at bruge billedet.',
    consentRest: ' Jeg har selv taget eller lavet det, eller jeg har tilladelse fra den, der har (også til logoer og designs). ' +
      'Personer, der kan genkendes på billedet, er indforståede med, at det bruges. ' +
      'Jeg ved, at varen laves specielt til mig og derfor ikke kan fortrydes.',
    // Vilkårsdel af det ENE flueben, pr. produkttype. [tekst](href) bliver til links (ny fane, rel=noopener).
    terms: {
      poster: ' Jeg har læst og accepterer [vilkårene for Print dit eget billede](/policies/terms-of-service) og [handelsbetingelserne](/policies/terms-of-service).',
      mug: ' Jeg har læst og accepterer [handelsbetingelserne](/policies/terms-of-service).',
      golfball: ' Jeg har læst og accepterer [handelsbetingelserne](/policies/terms-of-service).',
      ornament: ' Jeg har læst og accepterer [handelsbetingelserne](/policies/terms-of-service).'
    },
    needConsent: 'Sæt flueben ved »Jeg har ret til at bruge billedet …«, før du sender billedet.',
    needConsentCart: 'Sæt flueben ved »Jeg har ret til at bruge billedet …«, før du lægger varen i kurven.',
    small: 'Sender du et billede uden at bestille, sletter vi det efter 7 dage. Billeder til en ordre sletter vi senest 30 dage ' +
      'efter levering; den korrektur, du godkender, gemmer vi i 3 år. Du kan bede om sletning på kundeservice@lavettildig.dk med ' +
      'ordrenummer og den e-mail, du bestilte med. Læs mere i vores ',
    privacyLink: 'privatlivspolitik',
    privacyHref: '/policies/privacy-policy'
  };

  var T = {
    drop: 'Træk dit billede hertil, eller klik for at vælge fil',
    hint: 'JPG, PNG eller WebP, højst {mb} MB.',
    needConsent: LEGAL.needConsent,
    needConsentCart: LEGAL.needConsentCart,
    uploading: 'Sender billedet… {pct}%',
    checking: 'Kontrollerer filen…',
    done: 'Billedet er sendt',
    remove: 'Fjern billede',
    retry: 'Prøv igen',
    heicPending: 'Billedet vises, når det er sendt',
    badType: 'Filtypen understøttes ikke. Send et JPG-, PNG- eller WebP-billede.',
    tooBig: 'Filen er for stor. Maks. {mb} MB.',
    network: 'Kunne ikke kontakte tjenesten, der modtager billedet. Tjek din forbindelse og prøv igen.',
    generic: 'Noget gik galt, da billedet blev sendt. Prøv igen.',
    required: 'Send dit billede, før du lægger varen i kurven.',
    busy: 'Vent venligst, mens billedet sendes…',
    tokenFail: 'Billedet kunne ikke sendes. Prøv igen om lidt.',
    removeFail: 'Billedet er fjernet fra kurven og slettes automatisk efter 7 dage. Skriv til kundeservice, hvis du vil have det slettet med det samme.',
    keptPrevious: 'Den nye fil blev ikke brugt. Dit tidligere billede ({name}) er stadig valgt.',
    // AI-forbedring (fase 1)
    tier: { green: 'God kvalitet ({dpi} DPI).', yellow: 'Acceptabel kvalitet ({dpi} DPI) – kan blive lidt blødt.', orange: 'Lav kvalitet ({dpi} DPI) – tryk kan blive sløret eller pixeleret.', red: 'For lav kvalitet ({dpi} DPI) – billedet kan ikke trykkes i denne størrelse.' },
    enhTitle: 'Forbedr billedet automatisk (gratis)',
    enhBody: 'Vi kan forstørre billedet med AI, så det bliver skarpere i tryk. Du ser før og efter og vælger selv – dit originale billede gemmes også.',
    enhKindQ: 'Hvad er det for et billede?',
    enhPhoto: 'Foto', enhGraphic: 'Grafik, tegning eller logo',
    enhGo: 'Forbedr automatisk',
    enhQueued: 'I kø (nr. {pos}) – {eta} tilbage.',
    enhRunning: 'Forbedrer dit billede – {eta} tilbage. Du kan blive på siden imens.',
    enhUnavailable: 'Automatisk forbedring er ikke tilgængelig lige nu. Du kan fortsætte med dit originale billede.',
    enhDone: 'Færdig! Træk i skyderen for at sammenligne (udsnit i 100 %).',
    enhBefore: 'Før', enhAfter: 'Efter',
    enhSlider: 'Sammenlign før og efter',
    useEnh: 'Brug det forbedrede billede – {q}',
    useOrig: 'Brug mit originale billede – {q}',
    origBlocked: 'Dit originale billede er for lille til at blive trykt. Vælg det forbedrede billede eller send et større billede.',
    needChoice: 'Vælg, om du vil bruge det forbedrede eller det originale billede.',
    acceptLow: 'Jeg accepterer, at tryk kan blive sløret eller pixeleret.',
    needAcceptLow: 'Sæt flueben for at acceptere den lave kvalitet – eller vælg det forbedrede billede.',
    blockedRed: 'Billedet har for lav kvalitet til denne størrelse. Prøv automatisk forbedring eller send et større billede.',
    // Hybrid (UDKAST – tekster godkendes af Direktør før live)
    autoTitle: 'Vi forbedrer dit billede efter bestilling',
    autoBody: 'Forbedringen tager lidt tid, så du behøver ikke vente. Her er en hurtig visning af et udsnit – det endelige resultat bliver typisk skarpere end visningen.',
    autoBefore: 'Uden forbedring', autoAfter: 'Hurtig visning',
    autoConsent: 'Ja, forbedr mit billede automatisk med AI før print',
    autoNote: 'Du kan lægge varen i kurven nu. Er resultatet ikke godt nok, kontakter vi dig, før vi trykker.',
    autoReadyTitle: 'Dit forbedrede billede er klar',
    autoReadyBody: 'Forbedringen blev færdig, mens du var her. Træk i skyderen for at se forskellen.',
    autoNeeded: 'Dit originale billede er for lille til tryk. Sæt flueben for automatisk forbedring – eller send et større billede.',
    min: 'ca. {n} min', sec: 'under et minut',
    redPixels: 'For få pixels ({dpi} DPI, men under 1 megapixel) – billedet kan ikke trykkes i denne størrelse.'
  };
  // Slette-nøgler (upload-id -> nøgle) gemmes KUN i browseren (localStorage), aldrig i ordrelinjen.
  // Samme nøgle og format bruges af widget/cart-delete.js i kurven.
  var KEY_STORE = 'lvd_upload_keys', KEY_MAX_AGE = 8 * 864e5, TOKEN_FRESH_MS = 14 * 60e3; // token lever 15 min på serveren
  function readKeys() {
    try { var o = JSON.parse(window.localStorage.getItem(KEY_STORE) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
  }
  function writeKeys(o) { try { window.localStorage.setItem(KEY_STORE, JSON.stringify(o)); } catch (e) { /* privat tilstand e.l. */ } }
  function saveKey(id, key) {
    if (!id || !key) return;
    var o = readKeys(), now = Date.now();
    Object.keys(o).forEach(function (k) { if (!o[k] || now - o[k].t > KEY_MAX_AGE) delete o[k]; });
    o[id] = { k: key, t: now };
    var ids = Object.keys(o).sort(function (a, b) { return o[b].t - o[a].t; });
    ids.slice(50).forEach(function (k) { delete o[k]; });
    writeKeys(o);
  }
  function forgetKey(id) { var o = readKeys(); if (o[id]) { delete o[id]; writeKeys(o); } }
  // Sletter på serveren. Resolver true ved 204, ellers false (fejler aldrig).
  function deleteUpload(endpoint, id, tok) {
    var entry = readKeys()[id], h = {};
    if (entry && entry.k) h['X-Delete-Key'] = entry.k;
    if (tok) h.Authorization = 'Bearer ' + tok;
    if (!id || (!h.Authorization && !h['X-Delete-Key'])) return Promise.resolve(false);
    return fetch(endpoint + '/api/uploads/' + encodeURIComponent(id), { method: 'DELETE', headers: h, credentials: 'omit' })
      .then(function (r) { if (r.status === 204) { forgetKey(id); return true; } return false; }, function () { return false; });
  }

  var fmt = function (s, o) { return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k]; }); };

  var CSS = '.lvd{border:2px dashed #9aa3b2;border-radius:8px;padding:16px;margin:12px 0;font:inherit}' +
    '.lvd[data-state=over]{border-color:#1f6feb;background:rgba(31,111,235,.06)}' +
    '.lvd-drop{cursor:pointer;text-align:center;padding:12px}.lvd-drop:focus{outline:2px solid #1f6feb}' +
    '.lvd-hint{display:block;font-size:.85em;opacity:.7;margin-top:4px}' +
    '.lvd-bar{height:8px;background:#e5e7eb;border-radius:4px;overflow:hidden;margin-top:8px}' +
    '.lvd-bar>i{display:block;height:100%;width:0;background:#1f6feb;transition:width .15s}' +
    '.lvd-preview{display:flex;gap:12px;align-items:center}' +
    '.lvd-preview img{max-width:120px;max-height:120px;border-radius:4px;background:#eee}' +
    '.lvd-msg{margin-top:8px}.lvd-err{color:#b42318}.lvd-warn{color:#9a6700}.lvd-ok{color:#1a7f37}.lvd-note{color:#344054}' +
    '.lvd h3{margin:0 0 4px;font-size:1.05em}.lvd-help{margin:0 0 8px;font-size:.9em}' +
    '.lvd-consent{display:flex;gap:8px;align-items:flex-start;margin:10px 0;font-size:.9em;cursor:pointer}' +
    '.lvd-consent input{margin-top:3px}.lvd-consent-err{color:#b42318;font-weight:600;margin:-4px 0 8px;font-size:.9em}' +
    '.lvd-consent[data-invalid] {outline:2px solid #b42318;outline-offset:4px;border-radius:4px}' +
    '.lvd-quality{margin-top:4px;color:#9a6700}' +
    '.lvd-small{font-size:.8em;opacity:.8;margin-top:8px}' +
    '.lvd[data-consent=no] .lvd-drop{opacity:.55;cursor:not-allowed}' +
    '.lvd button{cursor:pointer;margin-top:6px}.lvd [hidden]{display:none!important}' +
    '.lvd-tier{margin-top:8px;padding:6px 10px;border-radius:6px;font-size:.92em}.lvd-tier[data-tier=green]{background:#e6f4ea;color:#1a7f37}' +
    '.lvd-tier[data-tier=yellow]{background:#fff8c5;color:#7d5c00}.lvd-tier[data-tier=orange]{background:#ffe8d4;color:#9a4700}.lvd-tier[data-tier=red]{background:#ffebe9;color:#b42318}' +
    '.lvd-enh{margin-top:10px;border:1px solid #d0d7de;border-radius:8px;padding:12px;background:#fafbfc}.lvd-enh h4{margin:0 0 4px;font-size:1em}' +
    '.lvd-enh p{margin:0 0 8px;font-size:.9em}.lvd-kinds{display:flex;gap:14px;flex-wrap:wrap;margin:6px 0;font-size:.9em}.lvd-kinds label{display:flex;gap:6px;align-items:center;cursor:pointer}' +
    '.lvd-go{background:#1f6feb;color:#fff;border:0;border-radius:6px;padding:8px 14px;font:inherit}.lvd-go[disabled]{opacity:.6}' +
    '.lvd-cmp{position:relative;width:100%;max-width:420px;aspect-ratio:1/1;overflow:hidden;border-radius:6px;margin:8px 0;background:#eee;user-select:none}' +
    '.lvd-cmp img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;image-rendering:auto}' +
    '.lvd-cmp .lvd-after{clip-path:inset(0 0 0 50%)}.lvd-cmp .lvd-line{position:absolute;top:0;bottom:0;left:50%;width:2px;background:#fff;box-shadow:0 0 3px rgba(0,0,0,.6);pointer-events:none}' +
    '.lvd-cmp .lvd-lab{position:absolute;top:6px;padding:2px 6px;font-size:.75em;background:rgba(0,0,0,.6);color:#fff;border-radius:4px}' +
    '.lvd-cmp input[type=range]{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:ew-resize;margin:0}' +
    '.lvd .lvd-kinds input,.lvd .lvd-choices input{width:16px!important;height:16px!important;min-width:0!important;flex:0 0 16px;margin:2px 0 0!important;padding:0!important;appearance:auto!important;-webkit-appearance:radio!important;border:0!important;border-radius:50%!important;box-shadow:none!important}' +
    '.lvd-choices{display:grid;gap:6px;font-size:.9em}.lvd-choices label{display:flex;gap:8px;align-items:flex-start;cursor:pointer}.lvd-choices label[aria-disabled=true]{opacity:.55;cursor:not-allowed}';

  function injectCss() {
    if (document.getElementById('lvd-css')) return;
    var s = document.createElement('style'); s.id = 'lvd-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }
  // Bygger tekst med [label](href)-links som DOM (ingen innerHTML). Kun faste tekster fra LEGAL bruges her.
  function appendLinked(parent, s) {
    var re = /\[([^\]]+)\]\(([^)]+)\)/g, last = 0, m;
    while ((m = re.exec(s))) {
      if (m.index > last) parent.appendChild(document.createTextNode(s.slice(last, m.index)));
      parent.appendChild(el('a', { href: m[2], target: '_blank', rel: 'noopener' }, m[1]));
      last = re.lastIndex;
    }
    if (last < s.length) parent.appendChild(document.createTextNode(s.slice(last)));
  }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (text != null) n.textContent = text;
    return n;
  }

  // Navne på linjeegenskaber pr. widget. Uden attributter: præcis som før (`_upload_id` og `_billedvalg`).
  // Flere widgets på samme side: data-property-suffix="_1" (eller data-index="1") => `_upload_id_1` og `_billedvalg_1`.
  // Står der kun data-property="_upload_id_<n>", følger billedvalg med som `_billedvalg_<n>`.
  function propertyNames(root) {
    var get = function (a) { var v = root.getAttribute(a); return v == null ? '' : String(v).trim(); };
    var suffix = get('data-property-suffix');
    if (!suffix && /^[1-9]$/.test(get('data-index'))) suffix = '_' + get('data-index');
    if (suffix && !/^_[1-9]$/.test(suffix)) suffix = ''; // kun _1.._9 (matcher serverens `_upload_id_<n>`)
    var explicit = get('data-property');
    if (!suffix && explicit) { var m = /^_upload_id(_[1-9])$/.exec(explicit); if (m) suffix = m[1]; }
    return { upload: explicit || ('_upload_id' + suffix), choice: '_billedvalg' + suffix, consent: '_rettigheder_accepteret' + suffix, suffix: suffix };
  }

  function init(root) {
    if (root.__lvd) return root.__lvd;
    var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    var productType = root.getAttribute('data-product-type') || 'mug';
    var required = root.getAttribute('data-required') === 'true';
    var maxMb = Number(root.getAttribute('data-max-mb')) || 25;
    var names = propertyNames(root), prop = names.upload;
    var formSel = root.getAttribute('data-form');
    var form = formSel ? document.querySelector(formSel) : (root.closest('form') || document.querySelector('form[action*="/cart/add"]'));

    injectCss();
    root.classList.add('lvd');
    root.textContent = '';
    var consentVersion = CONSENT_VERSION, consentHash = CONSENT_HASH; // teksten og versionen hører sammen – ikke konfigurerbar
    var heading = el('h3', null, LEGAL.heading);
    var help = el('p', { class: 'lvd-help' }, fmt(T.hint, { mb: maxMb }) + ' ' + LEGAL.helpRest);
    var consentLabel = el('label', { class: 'lvd-consent' });
    var consentBox = el('input', { type: 'checkbox', required: '' }); // aldrig sat på forhånd
    var consentText = el('span');
    consentText.appendChild(el('strong', null, LEGAL.consentBold));
    consentText.appendChild(document.createTextNode(LEGAL.consentRest));
    appendLinked(consentText, LEGAL.terms[productType] || LEGAL.terms.mug);
    consentLabel.appendChild(consentBox); consentLabel.appendChild(consentText);
    // Fejltekst lige ved fluebenet (læses op af skærmlæsere og står synligt ved feltet).
    var consentErr = el('div', { class: 'lvd-consent-err', id: 'lvd-cerr-' + Math.random().toString(36).slice(2), role: 'alert', 'aria-live': 'assertive' });
    consentBox.setAttribute('aria-describedby', consentErr.id);
    var small = el('p', { class: 'lvd-small' }, LEGAL.small);
    var link = el('a', { href: LEGAL.privacyHref, target: '_blank', rel: 'noopener' }, LEGAL.privacyLink);
    small.appendChild(link); small.appendChild(document.createTextNode('.'));
    root.setAttribute('data-consent', 'no');
    consentBox.addEventListener('change', function () {
      root.setAttribute('data-consent', consentBox.checked ? 'yes' : 'no');
      drop.setAttribute('aria-disabled', consentBox.checked ? 'false' : 'true');
      if (consentBox.checked) clearConsentError();
    });
    var input = el('input', { type: 'file', accept: 'image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif', hidden: '' });
    var drop = el('div', { class: 'lvd-drop', role: 'button', tabindex: '0', 'aria-disabled': 'true' });
    drop.appendChild(document.createTextNode(T.drop));
    var progress = el('div', { hidden: '' });
    var progText = el('div', { 'aria-live': 'polite' });
    var bar = el('div', { class: 'lvd-bar' }); var barFill = el('i'); bar.appendChild(barFill);
    progress.appendChild(progText); progress.appendChild(bar);
    var result = el('div', { class: 'lvd-preview', hidden: '' });
    var img = el('img', { alt: 'Forhåndsvisning af dit billede' });
    var info = el('div');
    var okText = el('div', { class: 'lvd-ok' }, T.done);
    var fileName = el('div', { class: 'lvd-hint' });
    var quality = el('div', { class: 'lvd-quality', 'aria-live': 'polite' }); // kvalitetsadvarsel for DET VISTE billede
    var removeBtn = el('button', { type: 'button' }, T.remove);
    info.appendChild(okText); info.appendChild(fileName); info.appendChild(quality); info.appendChild(removeBtn);
    // HEIC/HEIF kan browseren ikke vise: neutral tekst, indtil serverens visning (JPG-resultatet, nedskaleret) er hentet.
    var heicNote = el('div', { class: 'lvd-hint lvd-heic-note' }, T.heicPending); heicNote.hidden = true;
    result.appendChild(img); result.appendChild(heicNote); result.appendChild(info);
    var msg = el('div', { class: 'lvd-msg', role: 'alert', 'aria-live': 'assertive' });
    root.appendChild(heading); root.appendChild(help); root.appendChild(consentLabel); root.appendChild(consentErr);
    root.appendChild(input); root.appendChild(drop); root.appendChild(progress); root.appendChild(result); root.appendChild(msg); root.appendChild(small);

    var upscaleOn = root.getAttribute('data-upscale') === 'true';
    var autoPollMs = Number(root.getAttribute('data-auto-poll-ms')) || 5000;
    var dpiGuard = root.getAttribute('data-dpi-guard') === 'true'; // krus: widgetten håndhæver DPI-trin selv (Print dit eget billede: ltd-print.js)
    var enh = null; // { tier, dpi, choice, enhanced, usable, timer }
    var choiceHidden = null;
    var hidden = null, consentHidden = null, busy = false, token = null, tokenAt = 0, currentId = null, objUrl = null, current = null; // current = {id, name, warning}

    function setHidden(id) {
      if (!form || (!hidden && !id)) return;
      if (!hidden) {
        hidden = el('input', { type: 'hidden', name: 'properties[' + prop + ']' });
        form.appendChild(hidden);
      }
      hidden.value = id || '';
    }
    // Dokumentation på ordrelinjen (Legal: gem tidspunkt og tekstversion sammen med ordren).
    function setConsentHidden(value) {
      if (!form) return;
      if (!consentHidden) {
        consentHidden = el('input', { type: 'hidden', name: 'properties[' + names.consent + ']' });
        form.appendChild(consentHidden);
      }
      consentHidden.value = value || '';
    }
    function say(text, cls) { msg.textContent = text || ''; msg.className = 'lvd-msg' + (cls ? ' ' + cls : ''); }
    function showConsentError(text) {
      consentErr.textContent = text;
      consentLabel.setAttribute('data-invalid', '');
      consentBox.setAttribute('aria-invalid', 'true');
      if (consentLabel.scrollIntoView) { try { consentLabel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { consentLabel.scrollIntoView(); } }
      consentBox.focus();
    }
    function clearConsentError() {
      consentErr.textContent = ''; consentLabel.removeAttribute('data-invalid'); consentBox.removeAttribute('aria-invalid');
    }
    // Vis det aktuelle gyldige billede (eller ingenting) – bruges også til at gendanne efter en afvist fil.
    function showCurrent() {
      progress.hidden = true; input.value = '';
      barFill.style.width = '0%'; progText.textContent = '';
      if (current) {
        setHidden(current.id); drop.hidden = false; result.hidden = false;
        fileName.textContent = current.name; quality.textContent = current.warning || '';
      } else {
        setHidden(''); result.hidden = true; drop.hidden = false; quality.textContent = '';
      }
    }
    // Afvist fil: nulstil status/kvalitet fra den afviste fil, gendan det tidligere gyldige billede.
    function reject(text) {
      showCurrent();
      say(current ? text + ' ' + fmt(T.keptPrevious, { name: current.name }) : text, 'lvd-err');
    }
    function setBusy(b) { busy = b; root.setAttribute('aria-busy', b ? 'true' : 'false'); }
    function reset() {
      clearEnhance();
      if (objUrl) { URL.revokeObjectURL(objUrl); objUrl = null; }
      currentId = null; current = null; token = null; setConsentHidden('');
      showCurrent();
    }

    function validate(file) {
      if (!ALLOWED[file.type] && !EXT.test(file.name || '')) return T.badType;
      if (file.type && !ALLOWED[file.type]) return T.badType;
      if (file.size > maxMb * 1024 * 1024) return fmt(T.tooBig, { mb: maxMb });
      return null;
    }

    function getToken() {
      return fetch(endpoint + '/api/token', { method: 'POST' }).then(function (r) {
        if (!r.ok) throw new Error('token');
        return r.json();
      }).then(function (j) { return j.token; });
    }

    function send(file, tok) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        var fd = new FormData(); fd.append('file', file);
        var vEl = form && form.querySelector('[name="id"]');
        var vid = vEl && /^\d{6,20}$/.test(vEl.value) ? '&variant_id=' + vEl.value : '';
        xhr.open('POST', endpoint + '/api/uploads?product_type=' + encodeURIComponent(productType) + vid +
          '&consent=accepted&consent_version=' + encodeURIComponent(consentVersion) + '&consent_hash=' + consentHash);
        xhr.setRequestHeader('Authorization', 'Bearer ' + tok);
        xhr.upload.onprogress = function (e) {
          if (!e.lengthComputable) return;
          var pct = Math.round((e.loaded / e.total) * 100);
          barFill.style.width = pct + '%';
          progText.textContent = pct >= 100 ? T.checking : fmt(T.uploading, { pct: pct });
        };
        xhr.onerror = function () { reject({ network: true }); };
        xhr.onload = function () {
          var body = null; try { body = JSON.parse(xhr.responseText); } catch (e) { /* ingen JSON */ }
          if (xhr.status === 201 && body && body.id) resolve(body);
          else reject({ message: body && body.message });
        };
        xhr.send(fd);
      });
    }

    function handleFile(file) {
      if (busy || !file) return;
      if (!consentBox.checked) { showConsentError(T.needConsent); return; }
      say('');
      var problem = validate(file);
      if (problem) { reject(problem); return; }
      var prevToken = token, prevTokenAt = tokenAt;
      setBusy(true); setHidden('');
      drop.hidden = true; result.hidden = true; quality.textContent = ''; progress.hidden = false;
      barFill.style.width = '0%'; progText.textContent = fmt(T.uploading, { pct: 0 });
      getToken().catch(function () { throw { message: T.tokenFail }; }).then(function (tok) {
        token = tok; tokenAt = Date.now();
        return send(file, tok);
      }).then(function (res) {
        currentId = res.id; setHidden(res.id); saveKey(res.id, res.delete_key);
        setConsentHidden(consentVersion + ' sha256:' + consentHash + ' ' + new Date(res.consent_at || Date.now()).toISOString());
        if (objUrl) URL.revokeObjectURL(objUrl);
        // HEIC kan de fleste browsere ikke vise lokalt – så vises ingen lokal visning (billedet er modtaget og gemt som JPG).
        objUrl = null; img.removeAttribute('src');
        if (isHeic(file)) showServerPreview(res.id);
        else { objUrl = URL.createObjectURL(file); img.src = objUrl; img.hidden = false; heicNote.hidden = true; }
        var w = res.dpi && res.dpi.enabled ? null : res.warnings && res.warnings[0]; // DPI-trin erstatter den gamle pixelvarsel
        current = { id: res.id, name: file.name + ' (' + (file.size / 1048576).toFixed(1) + ' MB)', warning: w ? w.message : '' };
        showCurrent(); say('');
        startEnhance(res);
        root.dispatchEvent(new CustomEvent('lvd:uploaded', { bubbles: true, detail: { id: res.id, warnings: res.warnings || [], dpi: res.dpi || null, width: res.width, height: res.height } }));
      }).catch(function (e) {
        if (current) { token = prevToken; tokenAt = prevTokenAt; } // token til evt. sletning hører til det gendannede billede
        reject(e && e.network ? T.network : (e && e.message) || T.generic);
      }).then(function () { setBusy(false); });
    }

    // ── AI-forbedring ─────────────────────────────────────────────────────────────────────
    var tierBox = el('div', { class: 'lvd-tier', role: 'status' }); tierBox.hidden = true;
    var enhBox = el('div', { class: 'lvd-enh' }); enhBox.hidden = true;
    var enhMsg = el('div', { class: 'lvd-msg', role: 'status', 'aria-live': 'polite' });
    var lowWrap = el('label', { class: 'lvd-consent' }); var lowBox = el('input', { type: 'checkbox' });
    lowWrap.appendChild(lowBox); lowWrap.appendChild(el('span', null, T.acceptLow)); lowWrap.hidden = true;
    var mmss = function (ms) { var m = Math.ceil(ms / 60000); return ms < 60000 ? T.sec : fmt(T.min, { n: m }); };
    var tierText = function (t, dpi) { if (t === 'red' && dpi >= 72) return fmt(T.redPixels, { dpi: dpi }); return T.tier[t] ? fmt(T.tier[t], { dpi: dpi }) : ''; };
    function setChoiceHidden(v) {
      if (!form) return;
      if (!choiceHidden) { choiceHidden = el('input', { type: 'hidden', name: 'properties[' + names.choice + ']' }); form.appendChild(choiceHidden); }
      choiceHidden.value = v || '';
    }
    function clearEnhance() {
      if (enh && enh.timer) clearTimeout(enh.timer);
      enh = null; enhBox.hidden = true; enhBox.textContent = ''; tierBox.hidden = true; lowWrap.hidden = true; lowBox.checked = false; setChoiceHidden('');
    }
    function showTier(t, dpi) { tierBox.hidden = !T.tier[t]; tierBox.setAttribute('data-tier', t); tierBox.textContent = tierText(t, dpi); lowWrap.hidden = !(dpiGuard && t === 'orange' && (!enh || enh.choice !== 'enhanced')); if (!lowWrap.hidden && !lowWrap.parentNode) root.insertBefore(lowWrap, enhBox); }
    function emitChoice() {
      var e = enh; if (!e) return;
      var use = e.choice === 'enhanced' && e.enhanced ? e.enhanced : e.original;
      // Automatisk forbedring: forventet størrelse efter opskalering (original × skala), så temaets DPI-tjek låser op.
      if (e.choice === 'auto') use = { width: e.original.width * (e.autoScale || 4), height: e.original.height * (e.autoScale || 4) };
      root.dispatchEvent(new CustomEvent('lvd:choice', { bubbles: true, detail: { id: currentId, choice: e.choice, width: use.width, height: use.height, dpi: use.dpi, tier: use.tier } }));
    }
    function enhGuard() {
      if (!enh || !currentId) return null;
      if (enh.mode === 'auto') {
        if (enh.choice === 'auto') return null;
        if (dpiGuard && enh.original.tier === 'red') return T.autoNeeded;
        if (dpiGuard && enh.original.tier === 'orange' && !lowBox.checked) return T.needAcceptLow;
        return null;
      }
      if (enh.state === 'done' && !enh.choice) return T.needChoice;
      var tier = enh.choice === 'enhanced' ? enh.enhanced.tier : enh.original.tier;
      if (!dpiGuard) return null;
      if (tier === 'red') return enh.state === 'done' ? T.origBlocked : T.blockedRed;
      if (tier === 'orange' && !lowBox.checked) return T.needAcceptLow;
      return null;
    }
    function isHeic(file) { return HEIC_EXT.test(file.name || '') || /hei[cf]/i.test(file.type || ''); }
    function showServerPreview(id) {
      img.hidden = true; heicNote.hidden = false;
      fetch(endpoint + '/api/uploads/' + encodeURIComponent(id) + '/preview', { headers: { Authorization: 'Bearer ' + token } })
        .then(function (r) { if (!r.ok) throw new Error('visning'); return r.blob(); })
        .then(function (b) {
          if (id !== currentId) return;
          if (objUrl) URL.revokeObjectURL(objUrl);
          objUrl = URL.createObjectURL(b); img.src = objUrl; img.hidden = false; heicNote.hidden = true;
        }).catch(function () { /* teksten bliver stående; billedet er modtaget */ });
    }
    function api(path, opt) {
      opt = opt || {}; opt.headers = Object.assign({ Authorization: 'Bearer ' + token }, opt.headers || {});
      return fetch(endpoint + '/api/uploads/' + encodeURIComponent(currentId) + path, opt).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; });
      });
    }
    function startEnhance(res) {
      clearEnhance();
      if (!res.dpi || !res.dpi.enabled) return;
      enh = { state: 'none', original: { width: res.width, height: res.height, dpi: res.dpi.value, tier: res.dpi.tier }, choice: null };
      showTier(res.dpi.tier, res.dpi.value);
      if (!upscaleOn || !res.upscale || !res.upscale.offered) return;
      enhBox.hidden = false; enhBox.textContent = '';
      enhBox.appendChild(el('h4', null, T.enhTitle));
      enhBox.appendChild(el('p', null, T.enhBody));
      var kinds = el('div', { class: 'lvd-kinds', role: 'radiogroup', 'aria-label': T.enhKindQ });
      var name = 'lvd-kind-' + Math.random().toString(36).slice(2);
      [['photo', T.enhPhoto], ['graphic', T.enhGraphic]].forEach(function (k, i) {
        var l = el('label'); var r = el('input', { type: 'radio', name: name, value: k[0] }); if (!i) r.checked = true;
        l.appendChild(r); l.appendChild(document.createTextNode(k[1])); kinds.appendChild(l);
      });
      var go = el('button', { type: 'button', class: 'lvd-go' }, T.enhGo);
      var bar = el('div', { class: 'lvd-bar' }); var fill = el('i'); bar.appendChild(fill); bar.hidden = true;
      enhBox.appendChild(el('p', { style: 'margin:6px 0 0;font-weight:600' }, T.enhKindQ)); enhBox.appendChild(kinds); enhBox.appendChild(go); enhBox.appendChild(bar); enhBox.appendChild(enhMsg);
      enhMsg.textContent = ''; enhMsg.className = 'lvd-msg';
      go.addEventListener('click', function () {
        var kind = (kinds.querySelector('input:checked') || {}).value || 'photo';
        go.disabled = true; kinds.querySelectorAll('input').forEach(function (i) { i.disabled = true; });
        enhMsg.textContent = ''; enhMsg.className = 'lvd-msg';
        api('/enhance?kind=' + kind, { method: 'POST' }).then(function (j) {
          if (j._status !== 202) { unavailable(go); return; }
          enh.state = j.state; enh.t0 = Date.now(); enh.total = j.eta_ms || 60000;
          if (j.mode === 'auto') { showAuto(go); return; }
          bar.hidden = false; poll(j, fill, go);
        }).catch(function () { unavailable(go); });
      });
    }
    function unavailable(go) {
      if (!enh) return;
      enh.state = 'unavailable'; go.hidden = true; enhMsg.textContent = T.enhUnavailable; enhMsg.className = 'lvd-msg lvd-warn';
      enhBox.querySelectorAll('.lvd-bar').forEach(function (b) { b.hidden = true; });
    }
    function poll(j, fill, go) {
      if (!enh) return;
      var id = currentId;
      if (enh.mode === 'auto') return;
      if ((j.state === 'queued' || j.state === 'running') && (j.mode === 'auto' || Date.now() - enh.t0 > FAST_MS)) { showAuto(go); return; }
      if (j.state === 'queued' || j.state === 'running') {
        enh.total = Math.max(enh.total, (Date.now() - enh.t0) + (j.eta_ms || 0));
        fill.style.width = Math.min(95, Math.round(100 * (Date.now() - enh.t0) / enh.total)) + '%';
        enhMsg.textContent = fmt(j.state === 'queued' ? T.enhQueued : T.enhRunning, { pos: j.position || 1, eta: mmss(j.eta_ms || 0) });
        enh.timer = setTimeout(function () {
          api('/enhance').then(function (n) { if (enh && id === currentId) poll(n, fill, go); }).catch(function () { if (enh) enh.timer = setTimeout(function () { poll(j, fill, go); }, 5000); });
        }, 3000);
        return;
      }
      if (j.state === 'done') {
        fill.style.width = '100%';
        api('/enhance?compare=1').then(function (n) { if (enh && id === currentId) showResult(n, go); }).catch(function () { unavailable(go); });
        return;
      }
      unavailable(go);
    }
    // Hybrid: jobbet tager > ca. 20 s => hurtigt preview + flueben. Jobbet fortsætter i køen og kobles til ordren.
    var FAST_MS = 20000;
    function slider(before, after, lb0, la0) {
      var cmp = el('div', { class: 'lvd-cmp' });
      var b = el('img', { alt: lb0, src: before }); var a = el('img', { alt: la0, src: after, class: 'lvd-after' });
      var line = el('span', { class: 'lvd-line' });
      var rng = el('input', { type: 'range', min: '0', max: '100', value: '50', 'aria-label': T.enhSlider });
      var lb = el('span', { class: 'lvd-lab', style: 'left:6px' }, lb0), la = el('span', { class: 'lvd-lab', style: 'right:6px' }, la0);
      rng.addEventListener('input', function () { a.style.clipPath = 'inset(0 0 0 ' + rng.value + '%)'; line.style.left = rng.value + '%'; });
      [b, a, line, lb, la, rng].forEach(function (n) { cmp.appendChild(n); });
      return cmp;
    }
    function showAuto(go) {
      if (!enh || enh.mode === 'auto') return;
      if (enh.timer) clearTimeout(enh.timer);
      enh.mode = 'auto'; go.hidden = true;
      enhBox.querySelectorAll('.lvd-bar,.lvd-kinds').forEach(function (b) { b.hidden = true; });
      enhBox.querySelectorAll('p').forEach(function (p) { p.hidden = true; });
      var h = enhBox.querySelector('h4'); if (h) h.textContent = T.autoTitle;
      enhMsg.textContent = T.autoBody; enhMsg.className = 'lvd-msg';
      var holder = el('div'); enhBox.appendChild(holder);
      var id = currentId;
      api('/enhance/preview').then(function (p) { if (enh && id === currentId && p.scale) enh.autoScale = p.scale; if (enh && id === currentId && p.before) holder.appendChild(slider(p.before, p.after, T.autoBefore, T.autoAfter)); }).catch(function () {});
      var lab = el('label', { class: 'lvd-consent lvd-auto' }); var box = el('input', { type: 'checkbox' });
      lab.appendChild(box); lab.appendChild(el('span', null, T.autoConsent)); enhBox.appendChild(lab);
      enhBox.appendChild(el('p', { class: 'lvd-msg', style: 'margin:4px 0 0' }, T.autoNote));
      box.addEventListener('change', function () { choose(box.checked ? 'auto' : 'original'); });
      showTier(enh.original.tier, enh.original.dpi);
      // Langsomt job blev alligevel færdigt, mens kunden er på siden => skift preview ud med den rigtige skyder. Fluebenet røres ikke.
      var pollAuto = function () {
        if (!enh || id !== currentId || enh.mode !== 'auto') return;
        api('/enhance').then(function (n) {
          if (!enh || id !== currentId) return;
          if (n.state === 'queued' || n.state === 'running') { enh.timer = setTimeout(pollAuto, autoPollMs); return; }
          if (n.state !== 'done') return;
          return api('/enhance?compare=1').then(function (c) {
            if (!enh || id !== currentId || !c.compare) return;
            enh.enhanced = c.enhanced; enh.ready = true;
            holder.textContent = ''; var sl = slider(c.compare.before, c.compare.after, T.enhBefore, T.enhAfter); sl.className += ' lvd-ready'; holder.appendChild(sl);
            if (h) h.textContent = T.autoReadyTitle;
            enhMsg.textContent = T.autoReadyBody; enhMsg.className = 'lvd-msg lvd-ok';
          });
        }).catch(function () { if (enh) enh.timer = setTimeout(pollAuto, autoPollMs * 2); });
      };
      enh.timer = setTimeout(pollAuto, autoPollMs);
    }
    function showResult(j, go) {
      enh.state = 'done'; enh.enhanced = j.enhanced; go.hidden = true;
      enhBox.querySelectorAll('.lvd-bar,.lvd-kinds').forEach(function (b) { b.hidden = true; });
      enhMsg.textContent = T.enhDone; enhMsg.className = 'lvd-msg lvd-ok';
      if (j.compare) {
        var cmp = el('div', { class: 'lvd-cmp' });
        var b = el('img', { alt: T.enhBefore, src: j.compare.before }); var a = el('img', { alt: T.enhAfter, src: j.compare.after, class: 'lvd-after' });
        var line = el('span', { class: 'lvd-line' });
        var rng = el('input', { type: 'range', min: '0', max: '100', value: '50', 'aria-label': T.enhSlider });
        var lb = el('span', { class: 'lvd-lab', style: 'left:6px' }, T.enhBefore), la = el('span', { class: 'lvd-lab', style: 'right:6px' }, T.enhAfter);
        rng.addEventListener('input', function () { a.style.clipPath = 'inset(0 0 0 ' + rng.value + '%)'; line.style.left = rng.value + '%'; });
        [b, a, line, lb, la, rng].forEach(function (n) { cmp.appendChild(n); });
        enhBox.appendChild(cmp);
      }
      var ch = el('div', { class: 'lvd-choices', role: 'radiogroup' });
      var nm = 'lvd-ch-' + Math.random().toString(36).slice(2);
      var mk = function (val, label, disabled) {
        var l = el('label'); var r = el('input', { type: 'radio', name: nm, value: val }); if (disabled) { r.disabled = true; l.setAttribute('aria-disabled', 'true'); }
        l.appendChild(r); l.appendChild(el('span', null, label)); ch.appendChild(l);
        r.addEventListener('change', function () { choose(val); });
        return r;
      };
      var e = j.enhanced, o = enh.original;
      var re = mk('enhanced', fmt(T.useEnh, { q: tierText(e.tier, e.dpi) }), e.tier === 'red');
      mk('original', fmt(T.useOrig, { q: tierText(o.tier, o.dpi) }), o.tier === 'red' && dpiGuard);
      enhBox.appendChild(ch);
      if (e.tier !== 'red') { re.checked = true; choose('enhanced'); }
    }
    function choose(val) {
      if (!enh) return;
      enh.choice = val;
      if (enh.mode === 'auto') {
        setChoiceHidden(val === 'auto' ? 'Forbedres automatisk før print (AI)' : 'Original');
        lowWrap.hidden = val === 'auto' || !(dpiGuard && enh.original.tier === 'orange');
        if (!lowWrap.hidden && !lowWrap.parentNode) root.insertBefore(lowWrap, enhBox);
        emitChoice();
        api('/choice', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ choice: val }) }).catch(function () {});
        return;
      }
      var use = val === 'enhanced' ? enh.enhanced : enh.original;
      showTier(use.tier, use.dpi);
      setChoiceHidden(val === 'enhanced' ? 'AI-forbedret (' + use.width + ' × ' + use.height + ' px, ' + use.dpi + ' DPI)' : 'Original');
      enhMsg.className = 'lvd-msg lvd-ok'; enhMsg.textContent = T.enhDone;
      emitChoice();
      api('/choice', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ choice: val }) }).catch(function () {});
    }

    root.insertBefore(tierBox, small); root.insertBefore(enhBox, small); // lowWrap (ekstra flueben) indsættes først, når der er brug for det
    lowBox.addEventListener('change', function () { if (enhMsg.className.indexOf('lvd-err') >= 0) { enhMsg.textContent = ''; } });

    function openPicker() {
      if (busy) return;
      if (!consentBox.checked) { showConsentError(T.needConsent); return; }
      input.click();
    }
    drop.addEventListener('click', openPicker);
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker(); } });
    input.addEventListener('change', function () { handleFile(input.files && input.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { e.preventDefault(); root.setAttribute('data-state', 'over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { e.preventDefault(); root.removeAttribute('data-state'); });
    });
    root.addEventListener('drop', function (e) { handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    removeBtn.addEventListener('click', function () {
      var id = currentId, hasKey = !!(readKeys()[id] || {}).k;
      var tok = token && Date.now() - tokenAt < TOKEN_FRESH_MS ? token : null; // udløbet token prøves ikke
      reset(); say('');
      if (!id) return;
      // Ingen nøgle og intet gyldigt token (fx upload fra før kunde-sletning): prøv ikke; vis neutral besked (det er sandt).
      if (!hasKey && !tok) { say(T.removeFail, 'lvd-note'); return; }
      deleteUpload(endpoint, id, tok).then(function (ok) { if (!ok && !currentId) say(T.removeFail, hasKey ? 'lvd-err' : 'lvd-note'); });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); e.stopImmediatePropagation(); say(T.busy, 'lvd-err'); return; }
        if ((required || currentId) && !consentBox.checked) { e.preventDefault(); e.stopImmediatePropagation(); showConsentError(T.needConsentCart); return; }
        if (required && !currentId) { e.preventDefault(); e.stopImmediatePropagation(); say(T.required, 'lvd-err'); drop.focus(); return; }
        var g = enhGuard();
        if (g) { e.preventDefault(); e.stopImmediatePropagation(); say(g, 'lvd-err'); if (msg.scrollIntoView) msg.scrollIntoView({ block: 'center' }); }
      }, true);
    }
    root.__lvd = { handleFile: handleFile, reset: reset, consentBox: consentBox, consentErr: consentErr };
    return root.__lvd;
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-lvd-upload]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  window.LavettildigUpload = { init: init, deleteUpload: deleteUpload, REMOVE_FAIL: T.removeFail, propertyNames: propertyNames, initAll: initAll, CONSENT_VERSION: CONSENT_VERSION, CONSENT_HASH: CONSENT_HASH, LEGAL: LEGAL, hintFor: function (mb) { return fmt(T.hint, { mb: mb }); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // Shopify theme editor / sektionsgenindlæsning
  document.addEventListener('shopify:section:load', initAll);
})();
